<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$loading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Submit" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    @let agreement = agreementResource.value();
    @if (agreement) {
      <unity-textbox-readonly-control displayName="Agreement" [value]="agreement.name" />
    }
    @let formSchedule = formScheduleResource.value();
    @if (formSchedule) {
      <unity-textbox-readonly-control displayName="Form Name" [value]="formSchedule.name" />
      <unity-textbox-readonly-control displayName="Form Type" [value]="formSchedule.type_name" />

      @if (showDueDate(formSchedule) === true) {
        <unity-selector-date-range-control
          startDisplayName="Open Date"
          startDescription="Select the open date."
          endDisplayName="Due Date"
          endDescription="Select the due date."
          [startControl]="formGroup.controls.open_date"
          [endControl]="formGroup.controls.due_date" />
      } @else {
        <unity-selector-date-control displayName="Open Date" description="Select the open date." [control]="formGroup.controls.open_date" />
      }
    }
  </unity-card-new-shared>
</unity-page-container>
